import { render, staticRenderFns } from "./tronscanCollection.vue?vue&type=template&id=b20085e2&scoped=true"
import script from "./tronscanCollection.vue?vue&type=script&lang=js"
export * from "./tronscanCollection.vue?vue&type=script&lang=js"
import style0 from "./tronscanCollection.vue?vue&type=style&index=0&id=b20085e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20085e2",
  null
  
)

export default component.exports